export const htmlClassConstants = {
    btnClass: 'prc-btn',
    caretPrefix: 'caret',
}